query MarketingQuotaUsage {
  marketingQuotaUsage {
    month
    sent
    quota
  }
}
